import { PlusOutlined } from '@ant-design/icons';
import { Button, Col, Radio } from 'antd';
import { Trans, useTranslation } from 'react-i18next';
import { Outlet, useMatch } from 'react-router-dom';

import Filter from '../components/Filter';
import useTypedNavigate from '../hooks/useTypedNavigate';
import useTypedParams from '../hooks/useTypedParams';

const AccessManagementNavigator = () => {
  const { t } = useTranslation();

  const { tenant } = useTypedParams({ tenant: String });
  const navigate = useTypedNavigate();
  const match = useMatch(':tenant/settings/accessManagement/:activeTabKey/*');

  return (
    <>
      <Filter>
        <Col flex={1}>
          <Radio.Group
            options={[
              { value: 'accessProfiles', label: t('Perfis de acesso') },
              { value: 'users', label: t('Usuários') },
            ]}
            onChange={({ target: { value } }) => {
              switch (value) {
                case 'accessProfiles':
                  navigate(
                    {
                      pathname: '/:tenant/settings/accessManagement/accessProfiles/',
                      params: { tenant },
                    },
                    { replace: true }
                  );
                  break;
                case 'users':
                  navigate(
                    {
                      pathname: '/:tenant/settings/accessManagement/users/',
                      params: { tenant },
                    },
                    { replace: true }
                  );
                  break;
              }
            }}
            value={match?.params?.activeTabKey || 'accessProfiles'}
            optionType="button"
          />
        </Col>
        {match?.params?.activeTabKey === 'accessProfiles' && (
          <Col>
            <Button
              type="primary"
              icon={<PlusOutlined />}
              onClick={() =>
                navigate({
                  pathname: '/:tenant/settings/accessManagement/accessProfiles/create/',
                  params: { tenant },
                })
              }
            >
              {' '}
              <Trans>Novo perfil</Trans>
            </Button>
          </Col>
        )}
      </Filter>
      <Outlet />
    </>
  );
};

export default AccessManagementNavigator;
